var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRawhtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,2 v3 h20 v-3 h-19 v1 h18 v1 h-18 v-2 h-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11 L10 6 L11 7 L5 12 L11 17 L10 18 L4 13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5 L14 9.5 L15 10.5 L10 14.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6 L20 11 L20 13 L14 18 L13 17 L19 12 L13 7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19 v3 h20 v-3 h-19 v1 h18 v1 h-18 v-2 h-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRawhtml);
export default __webpack_public_path__ + "static/media/icon_rawhtml.3e88e002ec49185f5cf78e382e53827c.svg";
export { ForwardRef as ReactComponent };